import SelectTab from './selectTab';

export default SelectTab;
